module App {
    export class AppEventController implements ng.IComponentController {
        //binding
        eventlogAction: ITextValue[];

        //compute
        gridOptions: kendo.ui.GridOptions;
        gridObject: kendo.ui.Grid;

        // ========================================
        // INFRASTRUCTURE
        // ========================================
        static $inject: string[] = ['$scope', '$timeout', '$http', 'appConfig', 'authService', 'coreDataService', 'localeService', 'helperService'];
        constructor(
            private $scope: ng.IScope,
            private $timeout: ng.ITimeoutService,
            private $http: ng.IHttpService,
            private appConfig: AppConfig,
            private authService: AuthService,
            private coreDataService: CoreDataService,
            private localeService: LocaleService,
            private helperService: HelperService
        ) {
        }

        $onInit(): void {
            this.gridOptions = this.getGridOptions();
        }
        // ========================================
        // PUBLIC
        // ========================================
        // ========================================
        // PRIVATE
        // ========================================
        private getGridOptions(): kendo.ui.GridOptions {
            var that = this;
            return {
                // 1. DATASOURCE
                "dataSource": {
                    "type": 'webapi',
                    "transport": {
                        "read": this.appConfig.helper.http('get', this.appConfig.request.Eventlog.CompanyUrl, this.authService.getBearerTokenObject()),
                    },
                    "serverPaging": true,
                    "pageSize": 20,
                    "serverSorting": true,
                    "serverFiltering": true,
                    "sort": { "field": "DateTime", "dir": "desc" },
                    "filter": [],
                    "error": function(e:any) {
                        that.authService.kendoError(e, that.gridObject);
                    },

                    "schema": {
                        model: {
                            "id": "Id",
                            "fields": {
                                "Id": { "type": "number" },
                                "DateTime": { "type": "date" },
                                "Action": { "type": "string" },
                                "User": { "type": "string" },
                                "Details": { "type": "string" },
                                "IpAddress": { "type": "string" },
                            }
                        },
                        "data": "Data",
                        "total": "Total",
                        "errors": "Errors",

                    }

                },

                // 2. COLUMNS
                "columns": [
                    {
                        "field": "DateTime",
                        "title": "{{'Datarooms.Eventlog.DateTime' | translate}}",
                        "format": "{0:g}",
                        "filterable": true
                    }, {
                        "field": "IpAddress",
                        "title": "{{'Datarooms.Eventlog.IpAddress' | translate}}",
                    }, {
                        "field": "Action",
                        "title": "{{'Datarooms.Eventlog.Action' | translate}}",
                        "filterable": true,
                        "values": this.eventlogAction
                    }, {
                        "field": "User",
                        "title": "{{'Datarooms.Eventlog.User' | translate}}",
                        "filterable": true
                    }, {
                        "field": "Details",
                        "title": "{{'Datarooms.Eventlog.Details' | translate}}",
                        "filterable": true,
                        "template": "<translate-content input='dataItem.Details'></translate-content>",
                    }
                ],

                // 3. FEATURES
                "pageable": true,
                "sortable": true,
                "scrollable": false,
                "filterable": {
                    operators: this.localeService.getKendoFilterTranslationObject()

                },

                // 4. EVENTS
            }
        };

    }


    export class AppEventComponent implements ng.IComponentOptions {
        bindings: { [index: string]: string; } = {
            eventlogAction: '<'
        };

        controller = AppEventController;
        templateUrl = "/UserTemplate/EventlogTemplate";
    }

    angular.module("app").component("appEvent", new AppEventComponent());
}
